import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ProductionToolService extends Service {
	constructor(injector: Injector) {
		super("ProductionTool", injector);
	}

	// Tools with no billets yet - what is still to be broken down and designed.
	withNoBillets() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/WithNoBillets`);
	}
}
